export default __webpack_public_path__ + "static/BrandonGrotesque-Medium-910d5a4f448902e5efa2819ffeb867a1.woff2";